import React from 'react';
import { Box } from '@mui/material';
import { ReactComponent as DarkLogo } from '@assets/LogoDarkj.svg';

export const UiPageLoader = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box sx={{ animation: 'grayscale 2s infinite' }}>
        <DarkLogo />
      </Box>
    </Box>
  );
};
